<template>
    <div>
    <!-- all location popup    -->
        <confirmation-popup
    title="Location"
    message=""
    id="openLocationComponentAsPopup"
    :showConfirmBtn="true"
    :showCreateBtn="true"
    confirm-btn-text="Confirm"
    :show-cancel-btn="true"
    :close-after-confirm="false"
    cancel-btn-text="Cancel"
    @on-confirm="clickSubmit()">
            <form ref="LocationForm" id="LocationForm" :action="`/webservice//update-address-of-booking/${this.itemId}`" autocomplete="off" class="form-horizontal"
                  @submit.prevent="compareFieldworkers()" enctype="multipart/form-data" method="post">
                <booking-location-div
                v-model="value"
                :popup="true"
                :address-label='addressLabel'
                :booking-addresses-vue='bookingAddressesVue'
                :business-addresses='businessAddresses'
                :item-type='itemType'
                :company-business-type-all="CompanyBusinessTypeAll"
                :online-virtual-meeting-link="onlineVirtualMeetingLink"
                :inquiry-business-address="inquiryBusinessAddress"
                :inquiry-business-type='InquiryBusinessType'>
            </booking-location-div>
                <input type="submit" id="submitLoaction" class="hidden"/>
            </form>
</confirmation-popup>
    <!-- compare pricing popup    -->
    <confirmation-popup

        title="Price Changed"
        :message="priceChangedMessage"
        id="price_changed"
        :showConfirmBtn="true"
        :showCreateBtn="true"
        confirm-btn-text="Update price"
        :show-cancel-btn="true"
        cancel-btn-text="Keep price unchanged"
        confirm-id="UpdatePriceButton"
        :close-after-confirm="false"
        @on-confirm="updatePricing"
        @on-cancel="keepPriceUnchanged"
    >
    </confirmation-popup>
    <!-- compare fieldworker popup    -->

    <confirmation-popup

        title="Notice"
        :message="fieldworkerChangedMessage"
        id="fieldworker_changed"
        :showConfirmBtn="true"
        :showCreateBtn="true"
        confirm-btn-text="Assign to general fieldworker"
        :show-cancel-btn="true"
        cancel-btn-text="Keep fieldworker unchanged"
        @on-confirm="assignVisitToGeneral"
        @on-cancel="keepFieldworkerUnchnaged"
    >
    </confirmation-popup>
    </div>

</template>

<script>

import ConfirmationPopup from "../../../common/components/ConfirmationPopup.vue";
import axios from "axios";
import {EventBus} from "@/events/event-bus";

export default {
    name: "openLocationComponentAsPopup",
    components: {ConfirmationPopup},
    props: {
        value: {
            default() {
                return []
            }
        },
        CompanyBusinessTypeAll: '',
        businessAddresses: '',
        bookingAddressesVue: null,
        bookingAddress: null,
        inquiryBusinessAddress: null,
        InquiryBusinessType: null,
        onlineVirtualMeetingLink: null,
        addressLabel: '',
        services: null ,
        itemType:null,
        itemId:0,
        changedVisits: {} ,
    },
    data() {
        return {
            contractorId:null,
            priceChangedMessage:null,
            fieldworkerChangedMessage:null,
            current_Business_Type:null,
        }
    },
    computed: {


        isMobile() {
            return this.getWidth() <= 768;
        },
    },
    methods: {
        keepFieldworkerUnchnaged(){
            let vm = this;
            for (let service of vm.services) {
                for (let service_visit of service.visits){
                    for (let changedVisit of vm.changedVisits){
                        if (changedVisit.id === service_visit.id){

                            EventBus.$on('keepFieldworkerUnchnaged',changedVisit.oldContractorId);
                            service_visit.defaultFieldworker= response.data.generalContractor.user_id;
                            service_visit.fieldworkerChanged = false;
                        }
                    }
                }
            }

            this.comparePricing()
        },
        keepPriceUnchanged(){
          this.ResetLocationValues();
            for (let service of this.services) {
                EventBus.$emit('getAvailableFieldWorkersRequest',service.service_id,service.clone)
            }
        },
        clickSubmit(){
          document.getElementById('submitLoaction').click()
        },
        comparePricing(){
            if ( this.itemType != 'inquiry'&&  this.itemType != 'estimate'  && localStorage.getItem('old_total_qoute') && localStorage.getItem('old_total_qoute')!=document.getElementById('total_qoute').value){
                this.priceChangedMessage = "Notice: The price for your booking has changed from " + localStorage.getItem('old_total_qoute') + " to " + document.getElementById('total_qoute').value + " due to a change in location. Please confirm to proceed with the new pricing, or select 'Cancel' if you wish to keep the original booking details.";
                $('#price_changed').modal('show');
                localStorage.setItem('old_total_qoute', document.getElementById('total_qoute').value);
            }else{
                //
                for (let service of this.services) {
                    EventBus.$emit('getAvailableFieldWorkersRequest',service.service_id,service.clone)
                }
            }

        },
        compareFieldworkers(){
        this.UpdateAddressOnDatabase();
            if (this.changedVisits && this.changedVisits.length>0){
                let message = `Attention: Fieldworker Availability Issue<br><br>
You have changed the booking address, which impacts fieldworker assignments. Please review the details below:<br><br>
Affected Appointments:<br>`;

                this.changedVisits.forEach(visit => {
                    message += `<p>Appointment Date & Time - ${visit.startDate} at ${visit.startTime} - Service Name: ${visit.serviceName}<br>`;
                    message += `Assigned Fieldworker: [${visit.username}]<br>`;
                    message += `Status: Unavailable due to new location.</p>`;
                });

                message += `<br>Action Required:<br><br>
Confirm: Unassign the listed fieldworkers and reassign these appointments to the general fieldworker pool.<br>
Cancel: If you wish to make alternative arrangements or reconsider the address change.<br><br>
Note: This action is necessary because the assigned fieldworkers do not service the new address area.`;

// Display this message as HTML content

                this.fieldworkerChangedMessage =message;
                $('#fieldworker_changed').modal('show');
            }
            else{
                this.comparePricing()
            }
            $('#openLocationComponentAsPopup').modal('hide');
        },
        assignVisitToGeneral(){
            this.UpdateVisitAssignedFieldworker(this.changedVisits)
            this.comparePricing();

        },
        async UpdateAddressOnDatabase(){

            let onlineVirtualMeetingLink_js = $('#onlineVirtualMeetingLink_js').val()??0;

              try {

                 const form = this.$refs.LocationForm;
                const formData = new FormData(form); // Automatically captures all form data

                formData.append('item_id',this.itemId);
                formData.append('and_save_booking_business_type',  1 );
                formData.append('item_type',  this.itemType);
                formData.append('business_address',   this.current_Business_Type );
                formData.append('online_virtual_meeting_link', onlineVirtualMeetingLink_js );
                const response = await fetch("/save-booking-location", {
                    method: 'POST',
                    body: formData,
                });

                if (response.ok) {
                    // this.visit.contractorInfo.user_id
                        const responseData = await response.json(); // Parse JSON response
                        if (responseData.type === 'success') {
                             if ( this.current_Business_Type !='virtual'  &&  this.current_Business_Type !='mobile' ){
                               let address_data_fixed=[];
                               let data = {   "text_address": $("#business_addresses option:selected").text()       }
                               address_data_fixed.push(data)
                               EventBus.$emit('bookingAddressesChanged', address_data_fixed);
                             }
                             else if ( this.current_Business_Type !='virtual' ){
                               EventBus.$emit('bookingAddressesChanged', responseData.bookingAddresses);
                          }
                             else{
                               EventBus.$emit('bookingVirtual',  onlineVirtualMeetingLink_js);

                             }
                            $.notify('Address updated successfully', 'success');
                        }else{
                            $.notify('Failed to update address', 'error')
                        }
                    }

            } catch (error) {
                console.error(error);
                // Handle errors here
            }
        },
        updatePricing(){
          EventBus.$emit('submitWithoutRefresh')

        },
        UpdateVisitAssignedFieldworker(visits){
            let url = `/webservice/assign-visits-to-general`;
            let vm = this;
            let formDataInputs = new FormData();
            formDataInputs.append('visits',  btoa(JSON.stringify(visits)));
            window.axios.post(url, formDataInputs, {
                responseType: 'json', // default
            }).then(function (response) {
                for (let service of vm.services) {
                    for (let service_visit of service.visits){
                    for (let changedVisit of vm.changedVisits){
                        if (changedVisit.id === service_visit.id){
                            service_visit.defaultFieldworkerId= response.data.generalContractor.user_id;
                            service_visit.fieldworkerChanged = false;
                        }
                    }
                    }
                }
                window.onAddressChanged();
                setTimeout(function (e){
                    vm.changedVisits = [];
                },4000)
            });

        },
        ResetLocationValues(){
            var lat_1  = (localStorage.getItem('lat_localStorage'))
            var lon_1  =(localStorage.getItem('lng_localStorage'))
            var state_1  = (localStorage.getItem('state_localStorage'))
            var postcode_1  =(localStorage.getItem('postal_code_localStorage'))
            var suburb_1  =(localStorage.getItem('subpremise_localStorage'))
            var unit_lot_number_1  =(localStorage.getItem('unit_lot_number_localStorage'))
            var street_address_1  = (localStorage.getItem('street_address_localStorage'))
            var street_number_1  = (localStorage.getItem('street_number_localStorage'))
            var country_1  = (localStorage.getItem('country_localStorage'))

            $(".Location_details #lat_1").val(lat_1)
            $(".Location_details #lon_1").val(lon_1)
            $(".Location_details #state_1").val( state_1)
            $(".Location_details #postcode_1").val(postcode_1 )
            $(".Location_details #suburb_1").val(suburb_1)
            $(".Location_details #unit_lot_number_1").val(unit_lot_number_1)
            $(".Location_details #street_address_1").val( street_address_1)
            $(".Location_details #street_number_1").val( street_number_1)
            $(".Location_details #country_1").val( country_1)
            $(".Location_details #autocomplete_1").val(unit_lot_number_1 + " " + street_number_1+ " " + street_address_1+ " " + suburb_1+ " " + state_1+ " " + country_1+ " " + postcode_1)


            window.onAddressChanged();
        },
        getWidth() {
            let xWidth = null;
            if (window.screen != null)
                xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
                xWidth = window.innerWidth;

            if (document.body != null)
                xWidth = document.body.clientWidth;

            return xWidth;
        },
    },
    mounted() {
        var vm =this;
        this.$nextTick(function() {


            EventBus.$on('onBusinessTypeChanged', business_type => {

                this.current_Business_Type =   $("#business_addresses option:selected").val();
            });
            EventBus.$on('business-type-changed', current_Business_Type=> {
                 if (current_Business_Type == 'fixed') {
                    vm.current_Business_Type =$("#business_addresses option:selected").val();
                }else {
                    vm.current_Business_Type = current_Business_Type;
                }

            })

            var data_Business_Type;
            if(this.InquiryBusinessType  && this.InquiryBusinessType !='mobile' && this.InquiryBusinessType !='virtual'){
                  data_Business_Type='fixed';
            }else {
                  data_Business_Type=this.InquiryBusinessType ;

            }
            if(data_Business_Type){
              VueEventBus.$emit('onLoadOtherComponent', data_Business_Type)
            }
            if ( this.current_Business_Type == 'mobile'){
                 VueEventBus.$emit('onCustomerChanged', 0)
            }
        })



    }
}
</script>
<style scoped>
</style>